export enum OneColumnBannerVariant {
  ORIGINAL = 'original',
  NEXT_GEN_2024 = 'nextgen2024',
  ONE_COLUMN_BANNER_EMAIL = 'oneColumnBannerEmail'
}
